import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import '../Dashboard.css';
import withRoleAccess from '../../hoc/withRoleAccess';
import { useTranslation } from 'react-i18next';
import { Tabs } from 'antd';
import EditDeleteTeacher from './EditDeleteTeacher';
import EditDeleteStudent from './EditDeleteStudent';
import EditDeleteSubject from './EditDeleteSubject';
import FilterTaskTable from '../Class/FilterTaskTable';
import ClassChange from '../Class/ClassChange';
import Classes from '../Class/Classes';
import EditDeleteClassroom from './EditDeleteClassroom';
import AnnouncementAdmin from '../Announcement/AnnouncementAdmin';
import MatchTeacherSubject from '../SubjectMatch/MatchTeacherSubject';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import CreateTeacherForm from '../CreateUserform/CreateTeacherForm';
import CreateStudentForm from '../CreateUserform/CreateStudentForm';
import TutorClassLog from '../Teacher/TutorClassLog';
import CreateCourse from '../Class/CreateCourse';

// Custom CSS to be added to your Dashboard.css file
// .ant-tabs-tab {
//   font-size: 12px !important;
// }

function AdminPanel() {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState(searchParams.get('tab') || 'teachers');
  const [showCreateTeacherForm, setShowCreateTeacherForm] = useState(false);
  const [showCreateStudentForm, setShowCreateStudentForm] = useState(false);

  const toggleCreateTeacherForm = () => {
    setShowCreateTeacherForm(!showCreateTeacherForm);
  };

  const toggleCreateStudentForm = () => {
    setShowCreateStudentForm(!showCreateStudentForm);
  };

  const handleTabChange = (key) => {
    setActiveTab(key);
  };

  const items = [
    {
      key: 'teachers',
      label: t('tutors'),
      children: showCreateTeacherForm ? (
        <CreateTeacherForm onClose={toggleCreateTeacherForm} />
      ) : (
        <EditDeleteTeacher onCreateNewTeacher={toggleCreateTeacherForm} />
      ),
    },
    {
      key: 'students',
      label: t('students'),
      children: showCreateStudentForm ? (
        <CreateStudentForm onClose={toggleCreateStudentForm} />
      ) : (
        <EditDeleteStudent onCreateNewStudent={toggleCreateStudentForm} />
      ),
    },
    {
      key: 'subjects',
      label: t('subjects'),
      children: <EditDeleteSubject />,
    },
    {
      key: 'classrooms',
      label: t('classrooms'),
      children: <EditDeleteClassroom />,
    },
    {
      key: 'class',
      label: t('createCourse1'),
      children: <Classes />,
    },
    {
      key: 'createcourse',
      label: t('createCourse2'),
      children: <CreateCourse />,
    },
    {
      key: 'courses',
      label: t('manageCourses'),
      children: <FilterTaskTable />,
    },
    {
      key: 'classchange',
      label: t('classchange'),
      children: <ClassChange />,
    },
    {
      key: 'annoucements',
      label: t('announcements'),
      children: <AnnouncementAdmin />,
    },
    {
      key: 'matchteachersubject',
      label: t('matchteachersubject'),
      children: <MatchTeacherSubject />,
    },
    {
      key: 'teacherhourlog',
      label: t('teacherhourlog'),
      children: <TutorClassLog />,
    },
  ];

  return (
    <div>
      <Sidebar />
      <Header />
      <div className="main">
        <div className="tabs-container">
          <Tabs
            activeKey={activeTab}
            onChange={handleTabChange}
            type="card"
            items={items}
            size="small"
            className="admin-tabs-small"
          />
        </div>
      </div>
    </div>
  );
}

export default withRoleAccess(AdminPanel, ['admin', 'superadmin']);